import { Helmet } from 'react-helmet-async';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { NewImportConditionLinkContent } from './components/NewImportConditionLinkContent';
import { PageWithLayout } from '@/models/page';
import { Permission } from '@/models/user';

const NewImportConditionLinkPage: PageWithLayout = () => {
    return (
        <>
            <Helmet>
                <title>Regelwerk importieren | Starjack Admin</title>
            </Helmet>

            <NewImportConditionLinkContent />
        </>
    );
};

NewImportConditionLinkPage.isProtected = true;
NewImportConditionLinkPage.getLayout = (page) => (
    <SidebarLayout>{page}</SidebarLayout>
);
NewImportConditionLinkPage.permissions = [Permission.CONDITION_LINKS_NAV];

export default NewImportConditionLinkPage;
